import React from "react";
import moment from "moment";

import {
	AddVersionsToLibrary,
	ExportComplete,
	EncodeVastVideo,
	EncodeVideo,
	UploadVideo,
	BaseJCRM,
	ImportSocial,
	ImportCreativeLabels,
	ImportVersions,
	ImportVersionsPreview,
	CreativeTransition,
	UploadAudio,
	EncodeAudio
} from "./formatters/JCRM";

import DTreeNotification from "./formatters/DTree";
import TargetingSheetExport from "./formatters/TargetingSheetExport";

// the timestamp returned from sockets is in seconds
// JS dates use miliseconds`
const MILI = 1000;

// “Success” “Failed” “In Progress” “Waiting” for jobs, and for objects “Active” “Inactive” “Deleted”

const STATUS = {
	Info:{
		icon:"fas fa-info-circle is-info",
		title:"Warning",
	},
	Success:{
		icon:"fas fa-check-circle is-success",
		title:"Success",
	},
	Failed:{
		icon:"fas fa-times-circle is-error",
		title:"Error",
	},
	Waiting:{},
	"In Progress":{
		icon:"ft-ic fas fa-sync-alt is-loading-something",
		title:"In Progress...",
	},
	Active:{},
	Inactive:{},
	Deleted:{},
	warn:{
		icon:"fas fa-exclamation-triangle is-warn",
		title:"Warning",
	},
};

function StandardJCRM(props){
	let { info } = props;

	if(/export/gi.test(info.task)){
		return <ExportComplete {...props} />;
	} else if(/encode vast video/gi.test(info.task)){
		return <EncodeVastVideo {...props} />;
	} else if(/encode video/gi.test(info.task)){
		return <EncodeVideo {...props} />;
	} else if(/upload video/gi.test(info.task)){
		return <UploadVideo {...props} />;
	} else if(/import social creatives/gi.test(info.task)){
		return <ImportSocial {...props} />;
	} else if(/^import versions$/gi.test(info.task)){
		return <ImportVersions {...props} />;
	} else if(/^import versions with preview$/gi.test(info.task)){
		return <ImportVersionsPreview {...props} />;
	} else if (/creative status transition/gi.test(info.task)) {
		return <CreativeTransition {...props } />;
	} else if (/upload audio/gi.test(info.task)) {
		return <UploadAudio {...props} />;
	} else if (/encode vast audio|encode audio/gi.test(info.task)) {
		return <EncodeAudio {...props} />;
	} else if (/import creative labels/gi.test(info.task)) {
		return <ImportCreativeLabels {...props} />;
	} else if (/generate assets and versions/gi.test(info.task)){
		return <AddVersionsToLibrary {...props} />;
	}

	if(/encode many videos/gi.test(info.task)){
		return null;
	}

	return <BaseJCRM {...props} />;
}

export default function MessageItem({ info, component, markAsRead, apiBase }){
	let prettyTime = info.timestamp
		, iconInfo = STATUS.Info
		, $content = null
		;

	// Wrap this in a try/catch because moment is finicky
	try {
		prettyTime = moment(info.timestamp * MILI).fromNow();
	} catch (err){}

	// Wrap this in a try/catch to protect things
	if(STATUS[info.status]){
		iconInfo = STATUS[info.status];
	}

	function clearMessage(e){
		e.preventDefault();
		e.stopPropagation();
		markAsRead(info.id);
	}


	if(component && typeof(component) === "function"){
		let renderProps = {
				...info,
				prettyTime,
				iconInfo,
				clearMessage,
			}
			, Cm = component
			;
		$content = <Cm {...renderProps} />;
	} else {
		const commonProps = {
			info: {
				...info,
				prettyTime,
				iconInfo,
				apiBase,
			},
			clearMessage,
		};

		if(/jcrm/gi.test(info.origin)){
			let jcrmProps = {};
			$content = <StandardJCRM {...commonProps} {...jcrmProps} />;
		}
		if(/dtree/gi.test(info.origin)) {
			let dtreesProps = {};
			$content = <DTreeNotification {...commonProps} {...dtreesProps} />;
		}
		if(/itapi/gi.test(info.origin)) {
			switch (info.task) {
			case "Export YouTube Targeting Spreadsheet":
			case "Export Traffic Link Spreadsheet":
			case "Export Facebook Targeting Spreadsheet":
				$content = <TargetingSheetExport {...commonProps} />;
			default:
				break;
			}
		}
	}

	// If there's no content to display, don't include a message
	if(!$content){ return null; }
	// 	$content = [
	// 		<i key="status-icon" className={`ft-ic status-icon ${iconInfo.icon}`} title={iconInfo.title} />
	// 		, <div key="body" className="message-body">Some message</div>
	// 		, <i key="clear" className="ft-ic fal fa-times clear-message" title="Clear Message" onClick={clearMessage} />
	// 		, <b key="empty" />
	// 		, <span key="footer" className="message-footer">Library Name</span>
	// 		, <time key="time" className="message-time" dateTime={props.timestamp}>{prettyTime}</time>
	// 	];

	return <article className="message-item">{$content}</article>;
}

MessageItem.displayName = "MessageItem";
